import { Component, OnInit } from '@angular/core';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {

  driversList: any = [];
  driverColumns = ['checked', 'name', 'mobile', 'shifts', 'app_version', 'city', 'status', 'action'];
  showButtons = false;
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private storage: StorageService, private route: Router) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
  }

  selectAllDrivers(event: any) {
    this.showButtons = event.checked;
    this.driversList.forEach(element => {
      element.checked = event.checked;
    });
  }
}
